import "./VolumeControlComponent.scss";
import CommonService from "@/services/common.service";

interface VolumeControlComponentProps {
    volume: number;
    onVolumeChange: (volume: number) => void;
    projectId?: string;
}


const VolumeControlComponent = ({ volume, onVolumeChange }: VolumeControlComponentProps) => {
    return (
        <div className="volume-control">
            <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="volume-control__icon"
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            >
                <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
                <path d="M15.54 8.46a5 5 0 0 1 0 7.07"/>
                <path d="M19.07 4.93a10 10 0 0 1 0 14.14"/>
            </svg>
            <input
                type="range"
                min="0"
                max="1"
                step="0.1"
                value={volume}
                onChange={(e) => { CommonService.handleMixpanelTrack("Volume Control Changed", {
                    project_id: projectId,
                    volume: parseFloat(e.target.value),
                    is_requirement_gathering: true,
                    timestamp: new Date().toISOString()
                }); onVolumeChange(parseFloat(e.target.value))}}
                className="volume-control__slider"
                aria-label="Volume control"
            />
            <span className="volume-control__percentage">
                {Math.round(volume * 100)}%
            </span>
        </div>
    );
};

export default VolumeControlComponent;

